// extracted by mini-css-extract-plugin
module.exports = {"mdNote":"ModalNotes_mdNote__24W35","modalFooterButton":"ModalNotes_modalFooterButton__rwEBq"};